
import * as cdigit from 'cdigit';

export const isValidCNS = (value) => {
    if (value?.length === 13) {
        const stringToValidate = value.substring(0,11);
        const luhnVal = value.charAt(11);
        const verhoeffVal = value.charAt(12);
        return (
            value.match(new RegExp(process.env.REACT_APP_CNS_REGEX)) !== null &&
            cdigit.luhn.compute(stringToValidate) === luhnVal &&
            cdigit.verhoeff.compute(stringToValidate) === verhoeffVal
        );
    }
	return false;
}